import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import FreestarAd from '../FreestarAd/FreestarAdConnectLazy';
import { isCookieDisabled } from '../../helpers/Utils/parseOnetrust';
import { getFreestarAttributes } from '../../helpers/Utils/freestarUtils';
import { OPTANON_COOKIE, TRACKING } from '../../helpers/Utils/parseOnetrustConfig.config';
import { selectFeatureFlags } from '../../selectors/ContextSelector';
import * as styles from './GoogleAds.css';

const GoogleAds = ({ adId, automationId, pageType }) => {
    const { isNative } = useSelector(({ context = {} }) => context);
    const featureFlags = useSelector((state) => selectFeatureFlags(state));
    const { enableFreestarAdComponent = false } = featureFlags;
    const isTrackingCookieActive = !isCookieDisabled(TRACKING, OPTANON_COOKIE);
    const { context: { requestUrl = '' } = {} } = useSelector((context) => context);
    const { channel, freestarAdId } = getFreestarAttributes(adId, requestUrl);

    return (
        !isNative &&
        enableFreestarAdComponent &&
        isTrackingCookieActive && (
            <FreestarAd
                automationId={automationId}
                className={styles.adsBlock}
                placementName={freestarAdId}
                channel={channel}
                pageType={pageType}
            />
        )
    );
};

GoogleAds.defaultProps = {
    adId: '',
    automationId: 'ads-block',
    pageType: '',
};

GoogleAds.propTypes = {
    adId: PropTypes.string,
    automationId: PropTypes.string,
    pageType: PropTypes.string,
};

export default GoogleAds;
